var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 50,
    viewBox: "0 0 99 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2677 16.25H61C61.6904 16.25 62.25 16.8096 62.25 17.5V35C62.25 35.6904 61.6904 36.25 61 36.25H38.5C37.8097 36.25 37.25 35.6904 37.25 35V15C37.25 14.3097 37.8097 13.75 38.5 13.75H47.7677L50.2677 16.25ZM39.75 16.25V33.75H59.75V18.75H49.2323L46.7322 16.25H39.75ZM48.5 21.25H51V31.25H48.5V21.25ZM53.5 25H56V31.25H53.5V25ZM43.5 27.5H46V31.25H43.5V27.5Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.4dceb39d35c076f53057423c6c2ddb5d.svg";
export { ForwardRef as ReactComponent };